/* eslint-disable */
import { produce } from "immer";
import {
  CALCULATOR_CMS_CONFIG_FETCH_SUCCESS,
  CALCULATOR_CMS_CONFIG_FETCH_FAILURE,
  CALCULATOR_CMS_CONFIG_FETCH_START,
} from "../actions/types";

const calculatorCMSConfig = (
  state = {
    fetching: false,
    data: [],
    error: null,
  },
  action,
) => {
  switch (action.type) {
    case CALCULATOR_CMS_CONFIG_FETCH_START:
      return produce(state, (draft) => {
        draft.fetching = true;
      });
    case CALCULATOR_CMS_CONFIG_FETCH_SUCCESS:
      return produce(state, (draft) => {
        draft.fetching = true;
        draft.data = action.data;
        draft.fetching = false;
      });
    case CALCULATOR_CMS_CONFIG_FETCH_FAILURE:
      return produce(state, (draft) => {
        draft.fetching = false;
        draft.error = action.error;
      });
    default:
      return state;
  }
};

export default calculatorCMSConfig;
